const map = {
	"./HelpCenter/bg-img.png": 34517,
	"./ProductTraining/banner.png": 21979,
	"./ProductTraining/folder.png": 44277,
	"./ProductTraining/img1.png": 31699,
	"./ProductTraining/img2.png": 57208,
	"./ProductTraining/img3.png": 41825,
	"./ProductTraining/img4.png": 89358,
	"./ProductTraining/img5.png": 32375,
	"./about/Continuous Innovation(option).png": 55043,
	"./about/Continuous-Exploration-(option).png": 56775,
	"./about/about-core-hr.png": 73077,
	"./about/about-hero-bg.png": 74877,
	"./about/about-tab-img-old.png": 7114,
	"./about/about-tab-img.png": 29622,
	"./about/continuous-innovation.png": 53770,
	"./about/continuous-investment.png": 26592,
	"./about/for-a-better-tomorrow.png": 17319,
	"./about/icon-customer-experience-satisfaction.png": 2803,
	"./about/icon-customer-experience-satisfaction_.png": 69068,
	"./about/icon-exceptionalism-high-standards.png": 46546,
	"./about/icon-exceptionalism-high-standards_.png": 18719,
	"./about/icon-principles-beliefs.png": 56575,
	"./about/icon-principles-beliefs_.png": 64248,
	"./about/mission.png": 15707,
	"./about/payroll.png": 18050,
	"./api-docs/banner-bg.png": 39288,
	"./auth/3.mp4": 62104,
	"./auth/google.png": 34239,
	"./auth/hero-animation.png": 24975,
	"./auth/linkdin.png": 83157,
	"./auth/twitter.png": 5105,
	"./blockchain/block-chain-bg.png": 89799,
	"./blockchain/blockchain.png": 86664,
	"./blockchain/blockchain.svg": 62066,
	"./blog/blog_hero_image.png": 48987,
	"./blog/blog_hero_image.png__": 97978,
	"./blog/blog_hero_image_.png": 61108,
	"./blog/blog_img_2.png": 58063,
	"./blog/icon/arrow.png": 19581,
	"./blog/icon/arrow_2.png": 42158,
	"./blog/icon/like.png": 88525,
	"./blog/icon/message.png": 86067,
	"./blog/icon/minus-circle.png": 55445,
	"./blog/icon/plus-circle.png": 32811,
	"./blog/icon/rightArrow.png": 99805,
	"./blog/icon/share.png": 19767,
	"./blog/icon/“.png": 15966,
	"./blog/preview_img.png": 62002,
	"./blog/receiptsearch.png": 93318,
	"./blog/user.png": 74161,
	"./comp/404-Error.jpg": 84922,
	"./comp/Card03.png": 21242,
	"./comp/Content.png": 23116,
	"./comp/Content_old.png": 57114,
	"./comp/arrow.png": 99712,
	"./comp/arrow_active.png": 59415,
	"./comp/arrowright.png": 83488,
	"./comp/arrowright2.png": 94352,
	"./comp/blog_image.png": 60001,
	"./comp/check-circle-1.png": 68116,
	"./comp/check-circle-white.png": 11266,
	"./comp/check.png": 89051,
	"./comp/combo_product.png": 68293,
	"./comp/company_logo_1.png": 69058,
	"./comp/company_logo_2.png": 33593,
	"./comp/company_logo_3.png": 36688,
	"./comp/company_logo_4.png": 79535,
	"./comp/company_logo_5.png": 40518,
	"./comp/company_logo_6.png": 81757,
	"./comp/cross.png": 76811,
	"./comp/feature_icon.png": 50925,
	"./comp/finger_option1.png": 7269,
	"./comp/finger_print.png": 21916,
	"./comp/form.png": 35353,
	"./comp/hamburger.png": 58438,
	"./comp/ic_avatar.png": 69655,
	"./comp/ic_extra_chart.png": 42361,
	"./comp/ic_extra_form_validation.png": 41377,
	"./comp/icons/ArrowUpRight.png": 3580,
	"./comp/icons/search.png": 92410,
	"./comp/img1.png": 19013,
	"./comp/img2.png": 30862,
	"./comp/img3.png": 90231,
	"./comp/layer.png": 98476,
	"./comp/leftArrow.png": 37549,
	"./comp/mini_card1.png": 95324,
	"./comp/newsletter.png": 46010,
	"./comp/product.png": 3662,
	"./comp/product1.png": 56021,
	"./comp/product2.png": 88670,
	"./comp/product3.png": 6983,
	"./comp/schedule.png": 46004,
	"./comp/stat.png": 72717,
	"./comp/stat2.png": 61227,
	"./comp/stat_old.png": 98507,
	"./comp/storage_1.png": 46864,
	"./comp/tick-circle.png": 92847,
	"./comparewithrippling/Overview.png": 14375,
	"./comparewithrippling/heroCompare.png": 75265,
	"./comparewithrippling/rippling-row.png": 44410,
	"./comparewithrippling/rippling.png": 73573,
	"./comparewithrippling/smartOffice-row.png": 71856,
	"./comparewithrippling/smartOffice.png": 58031,
	"./customer/Aeroplanes.png": 66982,
	"./customer/Ascott Palace.jpg": 81692,
	"./customer/Card03.png": 47901,
	"./customer/DesignerCollection.png": 19851,
	"./customer/Executiv.png": 47441,
	"./customer/Green Grocery.jpg": 84094,
	"./customer/KX-Transport.png": 4249,
	"./customer/Majestic-Logo.png": 10190,
	"./customer/Musemind.jpg": 90710,
	"./customer/Naturo.jpg": 85871,
	"./customer/ajwah global.jpg": 90976,
	"./customer/bangas.jpg": 46802,
	"./customer/benazir-esita.png": 71754,
	"./customer/blvck-group.png": 64074,
	"./customer/customer-bg.png": 95854,
	"./customer/flow.png": 76596,
	"./customer/holiday-island.png": 3014,
	"./customer/ikaigai HR.jpg": 45303,
	"./customer/illiyeen.png": 71133,
	"./customer/illiyeen_bg.png": 67363,
	"./customer/item1.png": 74292,
	"./customer/item10.png": 3822,
	"./customer/item11.png": 3319,
	"./customer/item2.png": 95759,
	"./customer/item3.png": 14214,
	"./customer/item4.png": 16633,
	"./customer/item5.png": 10384,
	"./customer/item6.png": 40555,
	"./customer/item7.png": 50050,
	"./customer/item8.png": 55077,
	"./customer/item9.png": 19164,
	"./customer/knitexpert.png": 85468,
	"./customer/kx-electronics.png": 46091,
	"./customer/kx-sourcing.png": 56934,
	"./customer/legends.png": 57516,
	"./customer/marketplace.png": 69971,
	"./customer/max.png": 14088,
	"./customer/my-generation.png": 89847,
	"./customer/pathao.svg": 98451,
	"./customer/svg.png": 50152,
	"./customer/svg_old.png": 75254,
	"./feature/Featured1.png": 93467,
	"./feature/Featured2.png": 15136,
	"./feature/Featured3.png": 93257,
	"./feature/Team-calendar.png": 23014,
	"./feature/api-graphics.png": 83120,
	"./feature/attach-file.png": 73430,
	"./feature/attendance-employee.png": 56442,
	"./feature/attendance-hero.png": 7014,
	"./feature/attendance-management/Icon- Efficient Time Management.png": 96599,
	"./feature/attendance-management/Icon- Enhanced Communication.png": 47642,
	"./feature/attendance-management/Icon- Flexible Attendance Solutions.png": 86228,
	"./feature/attendance-management/Icon- Seamless Attendance Tracking.png": 20401,
	"./feature/attendance-management/attendance-employee.png": 32512,
	"./feature/attendance-management/attendance-hero.png": 26632,
	"./feature/attendance-management/employee-absent.png": 95160,
	"./feature/attendance-management/icon-enhanced-communication.png": 87455,
	"./feature/attendance-management/product-time.png": 71717,
	"./feature/attendance-management/time-tracking.png": 42529,
	"./feature/biometric1.png": 89805,
	"./feature/biometric2.png": 75830,
	"./feature/biometric3.png": 72767,
	"./feature/blockSecurity-hero-bg-old.png": 36162,
	"./feature/blockSecurity-hero-bg.png": 93502,
	"./feature/blockSecurity-hero.png": 40192,
	"./feature/blockchain-image.png": 90164,
	"./feature/blockchain-img.png": 12934,
	"./feature/blockchain-img2.png": 85382,
	"./feature/blockchain.png": 83828,
	"./feature/blockchain/ENHANCED USER VISIBILITY.png": 30908,
	"./feature/blockchain/Enhanced Accountability.png": 15910,
	"./feature/blockchain/Ensuring Peace of Mind.png": 22169,
	"./feature/blockchain/Ensuring Prompt Response to Suspicious Activities.png": 54746,
	"./feature/blockchain/GDPR COMPLIANCE.png": 29213,
	"./feature/blockchain/Staying Proactive with SmartPeople.png": 38165,
	"./feature/blockchain/Swift Identification of Unusual Activity.png": 81181,
	"./feature/blockchain/Transparency & Accountability.png": 69888,
	"./feature/blockchain/Transparency _ Accountability.png": 95535,
	"./feature/blockchain/Unprecedented Visibility.png": 41929,
	"./feature/blockchain/aligning-with-global-standards.png": 97926,
	"./feature/blockchain/block-chain-page-banner.png": 18793,
	"./feature/blockchain/empowering-users-to-take-ownership.png": 71051,
	"./feature/blockchain/i con-2 Unalterable Chain of Activities.png": 23123,
	"./feature/blockchain/icon-1 EXPERIENCE THE POWER OF BLOCKCHAIN.png": 69903,
	"./feature/calender.png": 53700,
	"./feature/chart.png": 3236,
	"./feature/clock.png": 98206,
	"./feature/communicate-better.png": 75680,
	"./feature/company-management/ability.png": 63838,
	"./feature/company-management/benefit.png": 55741,
	"./feature/company-management/company-management-hero.png": 75508,
	"./feature/company-management/company-specific.png": 15976,
	"./feature/company-management/employee-profile.png": 88310,
	"./feature/company-management/enhance-hr.png": 73043,
	"./feature/company-management/infromed-decision.png": 82741,
	"./feature/company-management/manage-multiple-2.png": 72383,
	"./feature/company-management/manage-multiple.png": 35870,
	"./feature/company-management/oversight.png": 10397,
	"./feature/company-management/real-time.png": 6462,
	"./feature/company-management/simlified-record.png": 56668,
	"./feature/company-management/streamlined.png": 86854,
	"./feature/company-management/switch.png": 33242,
	"./feature/company-management/tailored.png": 73400,
	"./feature/curve.png": 89493,
	"./feature/customer-solution.png": 50100,
	"./feature/dashboard-hifi-payroll.png": 5229,
	"./feature/data-protection.png": 4856,
	"./feature/deposit.png": 33694,
	"./feature/digital-noticeboard/Choose your target Audience.png": 23077,
	"./feature/digital-noticeboard/DIGITAL-NOTICE-BOARD.png": 26506,
	"./feature/digital-noticeboard/DIGITAL-NOTICE-BOARD_.png": 13463,
	"./feature/digital-noticeboard/Easy-Scheduling.png": 18523,
	"./feature/digital-noticeboard/Easy-Scheduling_.png": 45588,
	"./feature/digital-noticeboard/Further Segregation.png": 802,
	"./feature/digital-noticeboard/Manage-Segregation.png": 29148,
	"./feature/digital-noticeboard/Manage-Segregation_.png": 59265,
	"./feature/digital-noticeboard/Publish-Instantly.png": 77986,
	"./feature/digital-noticeboard/Publish-Instantly_.png": 36975,
	"./feature/digital-noticeboard/Schedule Notices with Ease.png": 85458,
	"./feature/digital-noticeboard/image11.png": 83187,
	"./feature/digital-noticeboard/image11_.png": 33100,
	"./feature/digital-noticeboard/image15.png": 93367,
	"./feature/digital-noticeboard/image15_.png": 53008,
	"./feature/digital-noticeboard/image75.png": 9521,
	"./feature/digital-noticeboard/image75_.png": 9986,
	"./feature/digital-noticeboard/improve Communication.png": 39158,
	"./feature/dollar.png": 91108,
	"./feature/domain-customization.png": 56986,
	"./feature/domain-customization/Benefit from reliable services for you.png": 8666,
	"./feature/domain-customization/Built for speed and security..png": 1460,
	"./feature/domain-customization/DOMAIN CUSTOMIZATION.png": 13432,
	"./feature/domain-customization/Domain Privacy.png": 3963,
	"./feature/domain-customization/Geo-location domains.png": 30949,
	"./feature/domain-customization/Lightning-fast search.png": 87932,
	"./feature/domain-customization/icon 1 Manage Time with Ease.png": 76379,
	"./feature/domain-customization/icon 2 Apply Shift Differentials.png": 24048,
	"./feature/domain-customization/icon 3 Improve Communication.png": 90523,
	"./feature/domain-customization2.png": 9298,
	"./feature/economies.png": 23732,
	"./feature/employee-absent.png": 22418,
	"./feature/employee-blockchain.png": 55767,
	"./feature/employee-leave.png": 80256,
	"./feature/employee-leave_old.png": 46974,
	"./feature/employee-monitoring-hero.png": 50726,
	"./feature/employee-monitoring/EMPLOYEE MANAGEMENT.png": 45679,
	"./feature/employee-monitoring/Embrace Efficiency.png": 2222,
	"./feature/employee-monitoring/Employee Groups.png": 82454,
	"./feature/employee-monitoring/Employee Onboarding.png": 51897,
	"./feature/employee-monitoring/Power in Unity.png": 83099,
	"./feature/employee-monitoring/Promotions, Perfected.png": 8076,
	"./feature/employee-monitoring/image100.png": 90636,
	"./feature/employee-monitoring/image22.png": 83405,
	"./feature/employee-monitoring/image22_.png": 94190,
	"./feature/employee-monitoring/image41.png": 92084,
	"./feature/employee-monitoring/image45.png": 70704,
	"./feature/employee-monitoring/image69.png": 4786,
	"./feature/employee-monitoring/image72.png": 80394,
	"./feature/employee-monitoring/image74.png": 35644,
	"./feature/employee-monitoring/image83.png": 49354,
	"./feature/employee-monitoring/image83_.png": 23831,
	"./feature/employee-monitoring/image93.png": 57213,
	"./feature/employee-tracking.png": 42942,
	"./feature/employee-wellbeing.png": 59108,
	"./feature/every-situation.png": 88186,
	"./feature/feature-payroll.png": 31378,
	"./feature/feature-payroll_old.png": 55648,
	"./feature/forms.png": 20553,
	"./feature/friendlyInterface.png": 31858,
	"./feature/future-hero-bg.png": 64256,
	"./feature/globe-slide.png": 62003,
	"./feature/globe.png": 9899,
	"./feature/growing.png": 28843,
	"./feature/hero1.png": 62037,
	"./feature/holiday-calender.png": 74793,
	"./feature/how-it-works.png": 63255,
	"./feature/ic.png": 50566,
	"./feature/industry-practise.png": 70484,
	"./feature/integrate-img.png": 74115,
	"./feature/integrate1.png": 8316,
	"./feature/integrate2.png": 92599,
	"./feature/integrate3.png": 49582,
	"./feature/integrate4.png": 85697,
	"./feature/integrate5.png": 17432,
	"./feature/integrate6.png": 91923,
	"./feature/leave-hero.png": 77588,
	"./feature/leave-management/Customizable Leave Types.png": 45564,
	"./feature/leave-management/Holiday Calendar and Weekends.png": 95417,
	"./feature/leave-management/LEAVE MANAGEMENT.png": 85532,
	"./feature/leave-management/Leave Analytics and Reports.png": 2847,
	"./feature/leave-management/Refocus on Employee wellbeing.png": 59897,
	"./feature/leave-management/Seamless Attendance Integration.png": 63924,
	"./feature/leave-management/Streamline Leave Requests.png": 33163,
	"./feature/leave-management/Take control of Employee leave.png": 73496,
	"./feature/leave-management/image48.png": 99915,
	"./feature/leave-management/image6.png": 7049,
	"./feature/leave-management/image7.png": 12576,
	"./feature/leave-policies.png": 92714,
	"./feature/leavemanagement-hero-bg.png": 85667,
	"./feature/monitoring.png": 7844,
	"./feature/no-pay.png": 71166,
	"./feature/notice-blockchain.png": 16319,
	"./feature/notice-board.png": 25245,
	"./feature/noticeboard-hero.png": 20263,
	"./feature/notification.png": 91471,
	"./feature/notification/Action Customization.png": 36269,
	"./feature/notification/CUSTOMIZED NOTIFICATION.png": 74014,
	"./feature/notification/Diverse Delivery Channels.png": 33894,
	"./feature/notification/Event Source Selection.png": 53485,
	"./feature/notification/Target Group Delivery.png": 38236,
	"./feature/notification/icon - 2 Action Customization.png": 91464,
	"./feature/notification/icon - 3 Target Group Delivery.png": 15051,
	"./feature/notification/icon - 4 Diverse Delivery Channels.png": 67658,
	"./feature/notification/icon- 1 Event Source Selection.png": 70322,
	"./feature/online-service.png": 80057,
	"./feature/organogram-management/ChartBar.png": 87341,
	"./feature/organogram-management/MapTrifold.png": 96882,
	"./feature/organogram-management/clear-hierarchy.png": 76145,
	"./feature/organogram-management/comprehensive.png": 39120,
	"./feature/organogram-management/dynamic.png": 69651,
	"./feature/organogram-management/expand-and-collapse.png": 95044,
	"./feature/organogram-management/interactive.png": 83588,
	"./feature/organogram-management/organogram-hero.png": 32888,
	"./feature/organogram-management/pan-across-chart.png": 14316,
	"./feature/organogram-management/position.png": 78411,
	"./feature/organogram-management/responsive-design.png": 47501,
	"./feature/organogram-management/scalability.png": 12845,
	"./feature/organogram-management/statistic.png": 91434,
	"./feature/overlay.png": 62064,
	"./feature/payroll-action.png": 53520,
	"./feature/payroll-mob-laptop.png": 60737,
	"./feature/payroll-notification.png": 41903,
	"./feature/payroll.png": 6375,
	"./feature/payroll/Automated Payroll Processing.png": 15494,
	"./feature/payroll/Compliance and Tax Management.png": 44336,
	"./feature/payroll/Dedicated Payroll Support.png": 52867,
	"./feature/payroll/Dynamic Pay Grade.png": 15582,
	"./feature/payroll/Error Free Salary Calculation.png": 24207,
	"./feature/payroll/Icon- 401(k) plans.png": 30055,
	"./feature/payroll/Icon- HR support.png": 34719,
	"./feature/payroll/Icon- Health benefits.png": 45640,
	"./feature/payroll/Icon- Worker_s comp.png": 58223,
	"./feature/payroll/Payroll Management Page.png": 28051,
	"./feature/payroll/Pre-Build Tax Template.png": 6407,
	"./feature/payroll/Tax Compliance with Confidence.png": 59504,
	"./feature/payroll/dadicated-payroll-support.png": 51243,
	"./feature/payroll/deposit.png": 61920,
	"./feature/payroll/deposit_.png": 33381,
	"./feature/payroll/dynamic-pay-grade.png": 55650,
	"./feature/payroll/dynamic-pay-grade_.png": 57583,
	"./feature/payroll/feature-payroll.png": 39484,
	"./feature/payroll/feature-payroll_.png": 86881,
	"./feature/payroll/forms.png": 24987,
	"./feature/payroll/overlay.png": 20534,
	"./feature/payroll/overlay_.png": 54051,
	"./feature/payroll/payroll-action.png": 42066,
	"./feature/payroll/payroll.png": 25457,
	"./feature/payroll/pre-build-tax.png": 47178,
	"./feature/payroll/pre-build-tax_.png": 44919,
	"./feature/payroll/stat.png": 83210,
	"./feature/payroll/stat2.png": 45954,
	"./feature/payroll/support.png": 73159,
	"./feature/payroll/support_.png": 44672,
	"./feature/person.png": 56009,
	"./feature/play-btn.png": 24679,
	"./feature/product-time.png": 11167,
	"./feature/protect-insurance.png": 65222,
	"./feature/reduce-bg-old.png": 15222,
	"./feature/reduce-bg.png": 39458,
	"./feature/reduce-img.jpg": 3962,
	"./feature/reduce-img.png": 44638,
	"./feature/revolutionize.png": 18117,
	"./feature/schedule-faster.png": 28975,
	"./feature/schedule-manage.png": 48033,
	"./feature/schedule-tracking.png": 295,
	"./feature/schedule.png": 14085,
	"./feature/secureStorage.png": 74902,
	"./feature/security-identity.png": 94653,
	"./feature/sheild.png": 38205,
	"./feature/shift-lock.png": 75938,
	"./feature/shift-management-hero.png": 72785,
	"./feature/shift-management/Automated Scheduling.png": 19879,
	"./feature/shift-management/Forecasting and Demand.png": 10892,
	"./feature/shift-management/Real-Time Notifications.png": 56669,
	"./feature/shift-management/Shift Cost Analysis.png": 32236,
	"./feature/shift-management/Shift Evaluation Surveys.png": 37972,
	"./feature/shift-management/Shift Management.png": 76110,
	"./feature/shift-management/Shift Performance Rewards.png": 38673,
	"./feature/shift-management/Shift Performance Tracking.png": 76754,
	"./feature/shift-management/Shift Reminders and Alerts.png": 54540,
	"./feature/shift-management/image3.png": 71197,
	"./feature/shift-management/image3_.png": 75838,
	"./feature/shift-management/image8.png": 60494,
	"./feature/solid-mark.png": 55087,
	"./feature/stars.png": 83967,
	"./feature/support.png": 50289,
	"./feature/tab-img.png": 95447,
	"./feature/take-controll-of-employee-leave.png": 63542,
	"./feature/task.png": 72909,
	"./feature/tax-calcalution.png": 76299,
	"./feature/tax-calcalution1.png": 99002,
	"./feature/tax-calcalution2.png": 20113,
	"./feature/tax-calcalution3.png": 9896,
	"./feature/tax-hero-old.png": 4962,
	"./feature/tax-management/Payroll Tax Calculation 2.png": 89947,
	"./feature/tax-management/Payroll Tax Configuration.png": 17648,
	"./feature/tax-management/Save-with-Potential-Tax-Credits/Enhanced Accuracy.png": 13738,
	"./feature/tax-management/Save-with-Potential-Tax-Credits/Expert Support.png": 88598,
	"./feature/tax-management/Save-with-Potential-Tax-Credits/Real-time Updates.png": 88735,
	"./feature/tax-management/Save-with-Potential-Tax-Credits/Scalable Solution.png": 1161,
	"./feature/tax-management/Save-with-Potential-Tax-Credits/Time-Savings-01.png": 5508,
	"./feature/tax-management/Save-with-Potential-Tax-Credits/Time-Savings-02.png": 42367,
	"./feature/tax-management/accuracy-guaranteed.png": 54160,
	"./feature/tax-management/image10.png": 85154,
	"./feature/tax-management/image10_.png": 72495,
	"./feature/tax-management/image34.png": 79276,
	"./feature/tax-management/image39.png": 9929,
	"./feature/tax-management/image39_.png": 7834,
	"./feature/tax-management/tax-hero-old.png": 63896,
	"./feature/tax-management/tax-hero.png": 74016,
	"./feature/tax-management/time-savings.png": 53489,
	"./feature/tax-management/time-savings_.png": 5602,
	"./feature/taxmanagement-hero.png": 11617,
	"./feature/time-tracking.png": 94647,
	"./feature/track-time-easier.png": 83713,
	"./feature/tracking-report.png": 18022,
	"./feature/video1.png": 91364,
	"./feature/zerohassle.png": 95778,
	"./hero/1.gif": 15028,
	"./hero/1.mp4": 24024,
	"./hero/animate-img.png": 31297,
	"./hero/combo_product.png": 88304,
	"./hero/finger_print.png": 5375,
	"./hero/future-hero.png": 4252,
	"./hero/hero bg.png": 78823,
	"./hero/hero-slide-bg.png": 52014,
	"./hero/slide-items/b-1.png": 79855,
	"./hero/slide-items/b-10.png": 39231,
	"./hero/slide-items/b-2.png": 58388,
	"./hero/slide-items/b-3.png": 79517,
	"./hero/slide-items/b-4.png": 34146,
	"./hero/slide-items/b-5.png": 8299,
	"./hero/slide-items/b-6.png": 94480,
	"./hero/slide-items/b-7.png": 729,
	"./hero/slide-items/b-8.png": 11342,
	"./hero/slide-items/b-9.png": 10839,
	"./hero/slide-items/g-1.png": 7182,
	"./hero/slide-items/g-2.png": 95333,
	"./hero/slide-items/g-3.png": 65916,
	"./hero/slide-items/g-4.png": 49523,
	"./hero/slide-items/g-5.png": 10666,
	"./hero/slide-items/g-6.png": 59649,
	"./hero/slide-items/g-7.png": 75032,
	"./hero/slide-items/g-8.png": 42511,
	"./hero/slide-items/g-9.png": 3494,
	"./hero/slide-items/new/b-1.png": 50108,
	"./hero/slide-items/new/b-10.png": 14470,
	"./hero/slide-items/new/b-2.png": 55191,
	"./hero/slide-items/new/b-3.png": 65198,
	"./hero/slide-items/new/b-4.png": 48289,
	"./hero/slide-items/new/b-5.png": 75576,
	"./hero/slide-items/new/b-6.png": 50067,
	"./hero/slide-items/new/b-7.png": 99306,
	"./hero/slide-items/new/b-8.png": 75901,
	"./hero/slide-items/new/b-9.png": 54772,
	"./hero/slide-items/new/g-1.png": 5469,
	"./hero/slide-items/new/g-10.png": 25705,
	"./hero/slide-items/new/g-2.png": 24262,
	"./hero/slide-items/new/g-3.png": 5807,
	"./hero/slide-items/new/g-4.png": 20432,
	"./hero/slide-items/new/g-5.png": 26681,
	"./hero/slide-items/new/g-6.png": 60098,
	"./hero/slide-items/new/g-7.png": 34251,
	"./hero/slide-items/new/g-8.png": 29212,
	"./hero/slide-items/new/g-9.png": 65125,
	"./hero/slide-items/new/p-1.png": 20378,
	"./hero/slide-items/new/p-10.png": 47680,
	"./hero/slide-items/new/p-2.png": 80273,
	"./hero/slide-items/new/p-3.png": 48232,
	"./hero/slide-items/new/p-4.png": 27847,
	"./hero/slide-items/new/p-5.png": 52062,
	"./hero/slide-items/new/p-6.png": 72437,
	"./hero/slide-items/new/p-7.png": 60812,
	"./hero/slide-items/new/p-8.png": 64827,
	"./hero/slide-items/new/p-9.png": 43282,
	"./hero/slide-items/new/r-1.png": 72940,
	"./hero/slide-items/new/r-10.png": 94518,
	"./hero/slide-items/new/r-2.png": 75591,
	"./hero/slide-items/new/r-3.png": 23102,
	"./hero/slide-items/new/r-4.png": 6193,
	"./hero/slide-items/new/r-5.png": 95976,
	"./hero/slide-items/new/r-6.png": 49187,
	"./hero/slide-items/new/r-7.png": 85082,
	"./hero/slide-items/new/r-8.png": 42861,
	"./hero/slide-items/new/r-9.png": 88964,
	"./hero/slide-items/old/b-1.png": 84709,
	"./hero/slide-items/old/b-10.png": 28673,
	"./hero/slide-items/old/b-2.png": 73230,
	"./hero/slide-items/old/b-3.png": 56375,
	"./hero/slide-items/old/b-4.png": 50584,
	"./hero/slide-items/old/b-5.png": 71713,
	"./hero/slide-items/old/b-6.png": 14282,
	"./hero/slide-items/old/b-7.png": 46195,
	"./hero/slide-items/old/b-8.png": 3924,
	"./hero/slide-items/old/b-9.png": 41405,
	"./hero/slide-items/old/g-1.png": 87428,
	"./hero/slide-items/old/g-2.png": 42079,
	"./hero/slide-items/old/g-3.png": 45750,
	"./hero/slide-items/old/g-4.png": 45577,
	"./hero/slide-items/old/g-5.png": 90752,
	"./hero/slide-items/old/g-6.png": 69083,
	"./hero/slide-items/old/g-7.png": 54866,
	"./hero/slide-items/old/g-8.png": 84021,
	"./hero/slide-items/old/g-9.png": 14924,
	"./hero/slide-items/old/p-1.png": 54683,
	"./hero/slide-items/old/p-2.png": 99648,
	"./hero/slide-items/old/p-3.png": 70825,
	"./hero/slide-items/old/p-4.png": 96566,
	"./hero/slide-items/old/p-5.png": 74655,
	"./hero/slide-items/old/p-6.png": 44740,
	"./hero/slide-items/old/p-7.png": 87245,
	"./hero/slide-items/old/p-8.png": 83386,
	"./hero/slide-items/old/p-9.png": 4963,
	"./hero/slide-items/old/r-1.png": 30453,
	"./hero/slide-items/old/r-10.png": 86193,
	"./hero/slide-items/old/r-2.png": 44702,
	"./hero/slide-items/old/r-3.png": 16039,
	"./hero/slide-items/old/r-4.png": 40872,
	"./hero/slide-items/old/r-5.png": 80817,
	"./hero/slide-items/old/r-6.png": 56154,
	"./hero/slide-items/old/r-7.png": 77731,
	"./hero/slide-items/old/r-8.png": 17508,
	"./hero/slide-items/old/r-9.png": 60013,
	"./hero/slide-items/p-1.png": 58569,
	"./hero/slide-items/p-2.png": 10386,
	"./hero/slide-items/p-3.png": 31931,
	"./hero/slide-items/p-4.png": 77124,
	"./hero/slide-items/p-5.png": 40365,
	"./hero/slide-items/p-6.png": 8598,
	"./hero/slide-items/p-7.png": 62399,
	"./hero/slide-items/p-8.png": 15336,
	"./hero/slide-items/p-9.png": 47377,
	"./hero/slide-items/r-1.png": 68095,
	"./hero/slide-items/r-10.png": 46319,
	"./hero/slide-items/r-2.png": 82820,
	"./hero/slide-items/r-3.png": 46061,
	"./hero/slide-items/r-4.png": 16082,
	"./hero/slide-items/r-5.png": 37627,
	"./hero/slide-items/r-6.png": 40064,
	"./hero/slide-items/r-7.png": 64265,
	"./hero/slide-items/r-8.png": 24862,
	"./hero/slide-items/r-9.png": 647,
	"./herocircle-1/calender.png": 76284,
	"./herocircle-1/chart.png": 68956,
	"./herocircle-1/clock.png": 82134,
	"./herocircle-1/dollar.png": 27596,
	"./herocircle-1/logo-old.png": 76463,
	"./herocircle-1/logo.png": 69911,
	"./herocircle-1/new-icon/Attendance Management 1.png": 39788,
	"./herocircle-1/new-icon/Block Chain 1.png": 9594,
	"./herocircle-1/new-icon/Digital Noticeboard 1.png": 93774,
	"./herocircle-1/new-icon/Domain Customization 1.png": 83637,
	"./herocircle-1/new-icon/Employee Management 1.png": 47955,
	"./herocircle-1/new-icon/Leave Management 1.png": 50456,
	"./herocircle-1/new-icon/Notification Center 1.png": 95102,
	"./herocircle-1/new-icon/Payroll Management 1.png": 76706,
	"./herocircle-1/new-icon/Shift Management 1.png": 24823,
	"./herocircle-1/new-icon/Tax Management 1.png": 63846,
	"./herocircle-1/person.png": 85185,
	"./herocircle-1/sheild.png": 38629,
	"./herocircle-1/task.png": 45525,
	"./herocircle-1/timeline.png": 29275,
	"./herocircle-1/validation.png": 45079,
	"./home/blockchain-technology-to-ensure-transparency-security-reliability.png": 70854,
	"./home/dynamic-workflow-automation.png": 39634,
	"./home/payroll-made-easier-with-smartpeople.png": 4602,
	"./home/people-management-made-easier-with-SmartPeople.png": 44074,
	"./infocard/calender.png": 60240,
	"./integrate-slider/brust-sms.png": 74415,
	"./integrate-slider/click-up.png": 60717,
	"./integrate-slider/dropbox.png": 49317,
	"./integrate-slider/gmail.png": 94137,
	"./integrate-slider/google.png": 15254,
	"./integrate-slider/microsoft.png": 14943,
	"./integrate-slider/slack.png": 74371,
	"./integrate-slider/trello.png": 50217,
	"./integrate-slider/zoom.png": 49578,
	"./keyfeature/all-features.png": 52840,
	"./keyfeature/all-features.svg": 75466,
	"./keyfeature/calender.png": 84449,
	"./keyfeature/chart.png": 12647,
	"./keyfeature/clock.png": 45853,
	"./keyfeature/dollar.png": 90981,
	"./keyfeature/globe.png": 77768,
	"./keyfeature/ic.png": 56807,
	"./keyfeature/icon-without-back/Attendance Management 1.png": 13777,
	"./keyfeature/icon-without-back/Attendance Management 2.png": 89114,
	"./keyfeature/icon-without-back/Attendance Management.png": 79744,
	"./keyfeature/icon-without-back/Block Chain 1.png": 26223,
	"./keyfeature/icon-without-back/Block Chain 2.png": 3764,
	"./keyfeature/icon-without-back/Block Chain.png": 96366,
	"./keyfeature/icon-without-back/Digital Noticeboard 1.png": 87231,
	"./keyfeature/icon-without-back/Digital Noticeboard 2.png": 73668,
	"./keyfeature/icon-without-back/Digital Noticeboard.png": 29918,
	"./keyfeature/icon-without-back/Domain Customization 1.png": 69942,
	"./keyfeature/icon-without-back/Domain Customization 2.png": 67917,
	"./keyfeature/icon-without-back/Domain Customization.png": 26159,
	"./keyfeature/icon-without-back/Employee Management 1.png": 74198,
	"./keyfeature/icon-without-back/Employee Management 2.png": 55821,
	"./keyfeature/icon-without-back/Employee Management.png": 76143,
	"./keyfeature/icon-without-back/Leave Management 1.png": 46215,
	"./keyfeature/icon-without-back/Leave Management 2.png": 26156,
	"./keyfeature/icon-without-back/Leave Management.png": 78886,
	"./keyfeature/icon-without-back/Notification Center 1.png": 97299,
	"./keyfeature/icon-without-back/Notification Center 2.png": 1688,
	"./keyfeature/icon-without-back/Notification Center.png": 22386,
	"./keyfeature/icon-without-back/Payroll Management 1.png": 85657,
	"./keyfeature/icon-without-back/Payroll Management 2.png": 2722,
	"./keyfeature/icon-without-back/Payroll Management.png": 58568,
	"./keyfeature/icon-without-back/Shift Management 1.png": 59996,
	"./keyfeature/icon-without-back/Shift Management 3.png": 84430,
	"./keyfeature/icon-without-back/Shift Management.png": 27877,
	"./keyfeature/icon-without-back/Tax Management 1.png": 64617,
	"./keyfeature/icon-without-back/Tax Management 2.png": 33650,
	"./keyfeature/icon-without-back/Tax Management.png": 32600,
	"./keyfeature/notification.png": 36594,
	"./keyfeature/person.png": 45024,
	"./keyfeature/sheild.png": 56612,
	"./keyfeature/task.png": 61328,
	"./logo/footer-logo.png": 50980,
	"./logo/logo.png": 56062,
	"./megamenu/$.png": 39421,
	"./megamenu/calendar.png": 60743,
	"./megamenu/chain.png": 52646,
	"./megamenu/clock.png": 62743,
	"./megamenu/docs.png": 3132,
	"./megamenu/earth.png": 31865,
	"./megamenu/new-icon/Attendance Management 1.png": 73563,
	"./megamenu/new-icon/Block Chain 1.png": 35089,
	"./megamenu/new-icon/Digital Noticeboard 1.png": 53509,
	"./megamenu/new-icon/Domain Customization 1.png": 94876,
	"./megamenu/new-icon/Employee Management 1.png": 11808,
	"./megamenu/new-icon/Leave Management 1.png": 14493,
	"./megamenu/new-icon/Notification Center 1.png": 46897,
	"./megamenu/new-icon/Payroll Management 1.png": 97515,
	"./megamenu/new-icon/Shift Management 1.png": 35622,
	"./megamenu/new-icon/Tax Management 1.png": 82811,
	"./megamenu/notification.png": 86952,
	"./megamenu/smartPeople.png": 92583,
	"./megamenu/status.png": 49543,
	"./megamenu/timeline.png": 59288,
	"./megamenu/user.png": 64084,
	"./overview/item-1.png": 42256,
	"./overview/item-2.png": 13547,
	"./overview/item-3.png": 92418,
	"./overview/item-4.png": 80317,
	"./overview/plane.png": 53657,
	"./recipe-library/2.mp4": 89071,
	"./recipe-library/Notification Center 1.png": 42691,
	"./recipe-library/Tax Management 1.png": 49273,
	"./recipe-library/australia.png": 10524,
	"./recipe-library/bangladesh.png": 68747,
	"./recipe-library/canada.png": 22134,
	"./recipe-library/content.png": 91089,
	"./recipe-library/slide1.png": 64456,
	"./recipe-library/slide2.png": 1315,
	"./recipe-library/slide3.png": 53562,
	"./recipe-library/slide4.png": 77333,
	"./recipe-library/slide5.png": 41420,
	"./recipe-library/slide5_old (1).png": 39020,
	"./recipe-library/slide5_old (2).png": 42185,
	"./recipe-library/slide5_old (3).png": 46338,
	"./recipe-library/slide5_old (4).png": 69279,
	"./recipe-library/slide5_old (5).png": 96696,
	"./recipe-library/uae.png": 68081,
	"./recipe-library/uk.png": 28804,
	"./recipe-library/usa.png": 71807,
	"./start-with-us/dashboard.png": 15112,
	"./works-slider/img1.png": 84530,
	"./works-slider/img2.png": 49065
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;